import Router from 'vue-router'

import vue from 'vue'
import establishments from '@/router/establishments'
import results from '@/views/results'
import missionday from '@/views/missionday'
import research from '@/views/research'
import groups from '@/views/groups'
import home from '@/views/home'
import login from '@/views/login/main'
import resetpassword from '@/views/user/resetPassword'
import newaccount from '@/views/user/newAccount'
import forgotpassword from '@/views/user/forgotPassword'
import main from '@/views/main/main'
import contact from '@/views/contact/main'
import store from '@/store/store'
import legal from '@/views/legal/main'
import tools from '@/views/tools/main'
import valuation from '@/views/valuation/main'
import help from '@/views/help/main'

vue.use(Router)

const mainRoutes = [
  establishments,
  {
    path: '/home',
    name: 'home',
    component: home
  },
  {
    path: '/program',
    name: 'program',
    component: () => import(/* webpackChunkName: "presentation" */
      '@/views/program'
    ),
    meta: {
      scrollToTop: true
    }
  },
  {
    path: '/results',
    name: 'results',
    component: results,
    meta: {
      scrollToTop: true
    }
  },
  {
    path: '/missionday',
    name: 'missionday',
    component: missionday,
    meta: {
      scrollToTop: true
    }
  },
  {
    path: '/contact',
    name: 'contact',
    component: contact,
    meta: {
      scrollToTop: true
    }
  },
  {
    path: '/legal',
    name: 'legal',
    component: legal,
    meta: {
      scrollToTop: true
    }
  },
  {
    path: '/tools',
    name: 'tools',
    component: tools,
    meta: {
      scrollToTop: true
    }
  },
  {
    path: '/valuation',
    name: 'valuation',
    component: valuation,
    meta: {
      scrollToTop: true
    }
  },
  {
    path: '/help',
    name: 'help',
    component: help,
    meta: {
      scrollToTop: true
    }
  },
  {
    path: '/groups',
    name: 'groups',
    component: groups,
    meta: {
      scrollToTop: true
    }
  },
  {
    path: '/research',
    name: 'research',
    component: research,
    meta: {
      scrollToTop: true
    }
  },
  {
    path: '*',
    redirect: '/home'
  }
]

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/:id?/resetpassword',
      name: 'resetpassword',
      component: resetpassword
    },
    {
      path: '/forgotpassword',
      name: 'forgotpassword',
      component: forgotpassword
    },
    {
      path: '/newaccount',
      name: 'newaccount',
      component: newaccount
    },
    {
      path: '/',
      name: 'main',
      component: main,
      redirect: 'program',
      children: mainRoutes
    }
  ]
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  const loggedIn = store.getters['user/isLoggedIn']

  if (requiresAuth && !loggedIn) {
    next({ path: '/login', query: { to: to.fullPath } })
  } else {
    if (to.matched.some(x => x.meta.scrollToTop)) {
      setTimeout(() => { window.scrollTo(0, 0) }, 100)
    }
    next()
  }
})

export default router
